import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ConsultationTimeline from 'FRONTEND/components/ConsultationTimeline';
import VitalLineChart from 'FRONTEND/components/VitalLineChart';
import { listFollowUpData, selectAllFollowUpConsultations, selectChartableVitals } from 'FRONTEND/reducers/followUpSlice';
import i18n from 'FRONTEND/utils/i18n';

const MedicalFollowUp = () => {
  const locale = useSelector((state) => state.user.locale);
  const dispatch = useDispatch();
  const consultationList = useSelector(selectAllFollowUpConsultations);
  const vitalList = useSelector(selectChartableVitals);

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const patientId = window.location.pathname.match(/.*\/patients\/(.*)\/medical-follow-up/)[1];
  useEffect(() => {
    dispatch(listFollowUpData({
      startDate,
      endDate,
      patientId,
    }));
  }, [startDate, endDate]);

  return (
    <>
      <Accordion
        square
        defaultExpanded
        sx={{ mb: 1 }}
      >
        <AccordionSummary
          sx={{ width: '100%' }}
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography sx={{ width: '33%', flexShrink: 0, paddingLeft: 1 }}>
            {i18n._('Filters')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
            <Stack direction='row' spacing={1}>
              <DatePicker
                value={startDate}
                onChange={setStartDate}
                label={i18n._('Start date')}
                format='L'
                disableFuture
                slotProps={{
                  textField: { size: 'small' },
                }}
              />
              <DatePicker
                value={endDate}
                onChange={setEndDate}
                label={i18n._('End date')}
                format='L'
                disableFuture
                slotProps={{
                  textField: { size: 'small' },
                }}
              />
            </Stack>
          </LocalizationProvider>
        </AccordionDetails>
      </Accordion>
      <ConsultationTimeline consultationList={consultationList} />
      {vitalList.map((vital) => vital.serie?.length > 1 ? (
        <VitalLineChart key={vital.label} {...vital} />
      ) : null)}
    </>
  );
};

export default MedicalFollowUp;
